import * as React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

export interface IconButtonProps {
	children?: string;
	className: string;
	href?: string;
	onClick?: () => void;
	tooltip?: string;
	dataItem?: any;
    disabled?: boolean;
}

export class IconButton extends React.Component<IconButtonProps, any> {
	render() {
        let {className, dataItem, onClick, href, disabled} = this.props;

        let attrs = (disabled) ? {className, disabled} : {className, onClick};
        let link;

		if (this.props.href) {
			link = <a href={href} {...attrs}><i></i><span>{this.props.children}</span></a>
		}
		else {
			link = <button {...attrs}><i></i><span>{this.props.children}</span></button>
		}

		if (this.props.tooltip == null) {
			return link;
		}

		const overlay = <Tooltip>{this.props.tooltip}</Tooltip>

		return (
			<OverlayTrigger placement="top" overlay={overlay} trigger={['focus', 'hover']}>
				{link}
			</OverlayTrigger>
		);
	}
}
